import { GET_VL_CONNECT_SUMMARY_REPORT } from '../../../Types'
import _ from 'lodash'



const VLConnectSummaryReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_VL_CONNECT_SUMMARY_REPORT:
  return {
    ...state,
    data: action.payload?.data || [],          // Make sure this exists
    totalRecords: action.payload?.totalRecords || 0, // And this exists
  };
    default:
      return state
  }
}
export default VLConnectSummaryReportReducer